module.exports = __webpack_public_path__ + "static/media/icon_9.cd943a17.svg";